module.exports = __webpack_public_path__ + "assets/img/IMG015.44674e84.png";